import { gql } from "@apollo/client";

export const getPublishedOffers = gql`
  query GetPublishedOffers(
    $OfferStatus: String
    $searchTerm: String
    $filter_status: String
    $limit: Int = 50
    $offset: Int = 0
  ) {
    getPublishedOffers(
      limit: $limit
      offset: $offset
      OfferStatus: $OfferStatus
      searchTerm: $searchTerm
      filter_status: $filter_status
    ) {
      offer_published_id
      published_status
      employeesemployee_id
      is_upcoming_renewal
      updated_by
      time_of_expiry
      status
      created_at
      updated_at
      participated_by
      published_by
      employee {
        employee_id
        employee_first_name
        employee_last_name
        employee_email
        emp_abbrv
      }
      reinsurer_participation {
        offer_published_participant_id
        participation_status
        offer_participant_percentage
        transaction_thread {
          uuid
          state
          message
          timestamp
          is_condition
          sender_name
        }
      }
      unread_messages {
        id
        offer_id
        status
      }

      offer {
        id
        offer_id
        facultative_offer
        place_it_id
        sum_insured
        premium
        offer_status
        expiry_status
        offer_from
        class_of_business {
          class_of_business_id
          business_name
          business_category
        }
        classofbusiness {
          business_name
        }
        insurer {
          insurer_id
          insurer_company_name
          insurer_company_email
        }
        offer_detail {
          policy_number
          period_of_insurance_from
          period_of_insurance_to
          insured_by
          currency
        }
      }
    }
  }
`;

export const fetchOfferParticipationTransactionThread = gql`
  query FetchOfferParticipationTransactionThread(
    $offer_published_participant: ID!
    $published_by: String
  ) {
    fetchOfferParticipationTransactionThread(
      offer_published_participant: $offer_published_participant
      published_by: $published_by
    ) {
      uuid
      state
      message
      timestamp
      is_condition
      sender_name
    }
  }
`;

export const fetchUnreadTransactionThreadMessagesForReinsurer = gql`
  query FetchUnreadTransactionThreadMessagesForReinsurer {
    fetchUnreadTransactionThreadMessagesForReinsurer {
      sender_name
      offer {
        offer_id
        facultative_offer
        place_it_id
        sum_insured
        premium
        offer_status
        expiry_status
        classofbusiness {
          class_of_business_id
          business_name
          business_category
        }
        insurer {
          insurer_id
          insurer_company_name
          insurer_company_email
        }
        offer_detail {
          policy_number
          period_of_insurance_from
          period_of_insurance_to
          insured_by
          currency
        }
        offer_published {
          offer_published_id
          reinsurer_participation {
            participation_status
            offer_participant_percentage
          }
        }
      }
      receivable {
        rep_first_name
        rep_last_name
        position
        rep_email
      }
      status
      receiver_type
      offer_published_participant_id
      id
      created_at
    }
  }
`;

export const fetchOfferSummaryCount = gql`
  query FetchOfferSummaryCount($reinsurer_id: Int!, $search_term: String) {
    fetchOfferSummaryCount(
      reinsurer_id: $reinsurer_id
      search_term: $search_term
    ) {
      missed_offers
      todays_offers
    }
  }
`;

export const fetchReinsurerRepresentativeLoyaltyPoints = gql`
  query FetchReinsurerRepresentativeLoyaltyPoints {
    fetchReinsurerRepresentativeLoyaltyPoints {
      total_loyalty_points
      total_redeemable_loyalty_points
    }
  }
`;

export const fetchPublishedOfferAuditTrail = gql`
  query FetchPublishedOfferAuditTrail($input: AuditTrailInput!) {
    fetchPublishedOfferAuditTrail(input: $input) {
      action
      actor
      created_at
    }
  }
`;

export const getCancelledOffers = gql`
  query GetCancelledOffers($filters: CancelledOfferFilters) {
    getCancelledOffers(filters: $filters) {
      brokerage
      offer_id
      offer_from
      offer_drawer
      offer_cancel_reason
      insurersinsurer_id
      facultative_offer
      id
      classofbusiness {
        class_of_business_id
        business_name
      }
      class_of_business {
        class_of_business_id
        business_name
      }
      offer_detail {
        offer_detail_id
        offersoffer_id
        policy_number
        insured_by
        currency
        offer_comment
        offer_details
        period_of_insurance_from
        period_of_insurance_to
      }
      insurer {
        insurer_id
        insurer_company_name
        insurer_company_email
      }
      offer_published {
        offer_published_id
        reinsurer_participation {
          offer_published_participant_id
          participation_status
          offer_participant_percentage
        }
      }
      unread_transaction_threads {
        id
        offer_published_participant_id
        sender_name
        status
        receiver_type
        created_at
        offer {
          offer_id
        }
        offer_published_participant {
          offer_published_participant_id
        }
      }
      transaction_thread {
        uuid
        state
        message
        timestamp
        sender_name
        is_condition
      }
    }
  }
`;
